import state from "./moduleStationState.js";
import mutations from "./moduleStationMutations.js";
import actions from "./moduleStationActions.js";
import getters from "./moduleStationGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
